/* eslint-disable import/no-cycle */
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import ProfileIcon from "./ProfileIcon";
import RewardsIcon from "./RewardsIcon";
import CartIcon from "./CartIcon";
import HamburgerMenuIcon from "./HamburgerMenuIcon";
import CookieToast from "../../../CookieToast";
// eslint-disable-next-line import/no-cycle
import FullScreenHomepageCartDropdown from "../../CartDropdown/FullScreenHomepageCartDropdown";
import amplitudeAnalytics, { AMPLITUDE_NAV_SECTION } from "../../../../../shared/utilities/amplitude";
import styles from "./NavIcons.module.css";
import * as elementsActions from "../../../../../redux/actions/elements";
import { getNavPartProps } from "../navigationBarBrandRefreshClasses";

const NavIcons = ({
  isLoggedIn,
  userFirstName,
  userLastName,
  cartQuantity,
  onToggleMobileMenu,
  toggleCartMenu,
  showCartMenu,
  showNotification,
  amountAdded,
  productAddedImagePath,
  className,
}) => {
  const history = useHistory();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  const handleProfileClick = () => {
    amplitudeAnalytics.trackClickNavPrimary({
      navElement: "Profile",
      navSection: AMPLITUDE_NAV_SECTION.TOP_NAV,
      pathname: location.pathname,
    });
    if (!isLoggedIn) {
      history.push("/login");
    } else {
      history.push("/user/profile");
    }
  };

  const handleRewardsClick = () => {
    amplitudeAnalytics.trackClickNavPrimary({
      navElement: "Rewards",
      navSection: AMPLITUDE_NAV_SECTION.TOP_NAV,
      pathname: location.pathname,
    });
    if (isLoggedIn) {
      history.push("/user/loyalty-rewards");
    } else {
      history.push("/create-account");
    }
  };

  const handleCartClick = () => {
    amplitudeAnalytics.trackClickNavPrimary({
      navElement: "Cart",
      navSection: AMPLITUDE_NAV_SECTION.TOP_NAV,
      pathname: location.pathname,
    });
  };

  const handleHamburgerClick = () => {
    if (!mobileMenuOpen) {
      amplitudeAnalytics.trackOpenHamburgerMenu({
        pathname: location.pathname,
      });
    }
    setMobileMenuOpen(!mobileMenuOpen);
    onToggleMobileMenu();
  };

  return (
    <div
      className={`${styles.navIcons} ${className || ""}`}
      data-part={getNavPartProps("nav-icons")}
    >
      <div
        className={styles.hamburgerWrapperMobile}
        data-part={getNavPartProps("hamburger-wrapper-mobile")}
      >
        <HamburgerMenuIcon onClick={handleHamburgerClick} />
      </div>
      <div className={styles.navIconsDesktop}>
        <div className={styles.iconWrapper} data-part={getNavPartProps("icon-wrapper")}>
          <ProfileIcon
            isLoggedIn={isLoggedIn}
            userFirstName={userFirstName}
            userLastName={userLastName}
            onClick={handleProfileClick}
          />
        </div>
        <div className={styles.iconWrapper} data-part={getNavPartProps("icon-wrapper")}>
          <RewardsIcon onClick={handleRewardsClick} />
        </div>
        {cartQuantity > 0 && (
          <div className={styles.iconWrapper} data-part={getNavPartProps("icon-wrapper")}>
            <CartIcon
              cartQuantity={cartQuantity}
              toggleCartMenu={toggleCartMenu}
              onClick={handleCartClick}
            />
            {showCartMenu && (
              <FullScreenHomepageCartDropdown toggleCartMenu={toggleCartMenu} />
            )}
            {showNotification && (
              <div className={styles.cartNotificationContainer}>
                <CookieToast
                  count={amountAdded}
                  imageUrl={productAddedImagePath}
                />
              </div>
            )}
          </div>
        )}
        <div
          className={`${styles.iconWrapper} ${styles.hamburgerWrapper}`}
          data-part={getNavPartProps("icon-wrapper")}
        >
          <HamburgerMenuIcon onClick={handleHamburgerClick} />
        </div>
      </div>
    </div>
  );
};

NavIcons.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  userFirstName: PropTypes.string,
  userLastName: PropTypes.string,
  cartQuantity: PropTypes.number.isRequired,
  onToggleMobileMenu: PropTypes.func.isRequired,
  toggleCartMenu: PropTypes.func.isRequired,
  showCartMenu: PropTypes.bool,
  showNotification: PropTypes.bool,
  amountAdded: PropTypes.number,
  productAddedImagePath: PropTypes.string,
  className: PropTypes.string,
};

NavIcons.defaultProps = {
  userFirstName: "",
  userLastName: "",
  showCartMenu: false,
  showNotification: false,
  amountAdded: 0,
  productAddedImagePath: null,
  className: "",
};

export const mapStateToProps = (state) => {
  const userInfo = state.user?.userInfo || {};
  const user = userInfo.user || {};
  return {
    userFirstName:
      user.firstName || user.firstname || state.user.userFirstName || "",
    userLastName:
      user.lastName || user.lastname || state.user.userLastName || "",
    showCartMenu: state.elements.showCartMenu,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  toggleCartMenu: () => dispatch(elementsActions.toggleCartMenu()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NavIcons);
